import { useEffect, useState } from 'react'

/** True while the CSS media query `q` matches; follows rotation and resizes. */
export default function useMediaQuery(q) {
  const read = () => (typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(q).matches : false)
  const [matches, setMatches] = useState(read)
  useEffect(() => {
    if (!window.matchMedia) return undefined
    const mq = window.matchMedia(q)
    const on = () => setMatches(mq.matches)
    on()
    mq.addEventListener('change', on)
    return () => mq.removeEventListener('change', on)
  }, [q])
  return matches
}

/**
 * A phone held sideways: landscape and under 500px tall (an iPhone is
 * 375–440px tall that way; an iPad or a laptop is never that short). The
 * Session Builder uses the whole width for five days then (Charles,
 * 2026-10-05: "when you hold the phone horizontally it shows 5 days …
 * no need for the sidebar").
 */
export const LANDSCAPE_PHONE = '(orientation: landscape) and (max-height: 500px)'
